export const SOURCE_LABELS: Record<string, string> = {
    DEBT_SCHEDULE: 'Debt Schedule',
    BUREAU: 'Credit Bureau',
    CHARGES: 'Charges',
};

export const formatLenderDate = (dateStr: string | undefined | null): string => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '-';
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};
